import { Component, OnInit, ViewChild, AfterViewInit, Inject } from '@angular/core';
import { ConfigService } from 'src/app/shared/services/config.service';
import { FormBuilder, FormControl, FormGroup, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { isMobile, isMobileXL, loadData } from 'src/app/shared/utils/helpers';
import { LoggedService } from 'src/app/shared/services/logged.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Producto } from 'src/app/shared/models/producto';
import { ProductosService } from 'src/app/shared/services/productos.service';
import { SnackbarService } from 'src/app/shared/services/snackbar.service';
import { TablasService } from 'src/app/shared/services/tablas.service';
import { CuentasService } from 'src/app/shared/services/cuentas.service';
import { Cuenta } from 'src/app/shared/models/cuenta';
import { forkJoin } from 'rxjs';
import { MatTableDataSource } from '@angular/material/table';
import { Direccion } from 'src/app/shared/models/direccion';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { CuentaDistribuidor } from 'src/app/shared/models/cuentaDistribuidor';

@Component({
  selector: 'app-direcciones-dialog',
  templateUrl: './direcciones-dialog.component.html'
})
export class DireccionesDialogComponent implements OnInit {

  mensaje: number = 0;
  form: FormGroup;
  idTipo: number;

  codigoEdit: number = -1;
  direccion: Direccion;



  constructor(
    private configService: ConfigService,
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<DireccionesDialogComponent>,
    private fb: FormBuilder,
    private loggedService: LoggedService,
    private productosService: ProductosService,
    private cuentasService: CuentasService,
    private snackBarService: SnackbarService,
    private tablasService: TablasService,

    @Inject(MAT_DIALOG_DATA) private data: any) {
    this.form = this.fb.group({

      calleNro: [''],
      ciudad: [''],
      codigoCoagra: [''],

      codigo: [0],
    })

    if (data.idTipo != null) {
      this.idTipo = data.idTipo;
    }
    if (data.d != null) {
      this.codigoEdit = data.d.codigo
      this.direccion = data.d


    }
  }

  public Etiquetas: {
    Bloqueo: string,
    Buscar: string,
    CalleNro: string,
    Ciudad: string,
    CodigoPostal: string,
    CreditoUtilizado: string,
    Cuit: string,
    DBEKR: string,
    DireccionEnvio: string,
    DireccionFacturacion: string,
    FechaVtoCredito: string,
    IdCondicionPago: string;
    IdDivision: string,
    IdGrupoCliente: string,
    IdMoneda: string,
    IdRegion: string,
    IdTaxClassification: string,
    IdTipoCliente: string,
    IdTipoCredito: string,
    IdZonaVendedor: string,
    LimiteCredito: string,
    Nombre: string,
    NroCliente: string,
    NroClientePartner: string,
    Pais: string,
    Provincia: string,
    Region: string,
    SinRegistros: string;
    SitioInternet: string,
    Status: string,
    Telefono: string,
    FuncionPartner: string,
    Email: string
    EmailOpcional: string
    SalesOffice: string
    CodigoBodegaMyV: string
    CodigoBodegaCoagra: string
  }


  ngOnInit() {
    this.dialogRef.beforeClosed().subscribe(() => this.dialogRef.close(this.mensaje));
    this.Etiquetas = {

      Bloqueo: this.configService.etiquetas.Cuentas.Bloqueo,
      Buscar: this.configService.etiquetas.Buscar,
      CalleNro: this.configService.etiquetas.Cuentas.CalleNro,
      Ciudad: this.configService.etiquetas.Cuentas.Ciudad,
      CodigoPostal: this.configService.etiquetas.Cuentas.CodigoPostal,
      CreditoUtilizado: this.configService.etiquetas.Cuentas.CreditoUtilizado,
      Cuit: this.configService.etiquetas.Cuentas.Cuit,
      DBEKR: this.configService.etiquetas.Cuentas.DBEKR,
      DireccionEnvio: this.configService.etiquetas.Cuentas.DireccionEnvio,
      DireccionFacturacion: this.configService.etiquetas.Cuentas.DireccionFacturacion,
      FechaVtoCredito: this.configService.etiquetas.Cuentas.FechaVtoCredito,
      FuncionPartner: this.configService.etiquetas.Cuentas.FuncionPartner,
      IdCondicionPago: this.configService.etiquetas.Cuentas.IdCondicionPago,
      IdDivision: this.configService.etiquetas.Cuentas.IdDivision,
      IdGrupoCliente: this.configService.etiquetas.Cuentas.IdGrupoCliente,
      IdMoneda: this.configService.etiquetas.Cuentas.IdMoneda,
      IdRegion: this.configService.etiquetas.Cuentas.IdRegion,
      IdTaxClassification: this.configService.etiquetas.IdTaxClassification,
      IdTipoCliente: this.configService.etiquetas.Cuentas.IdTipoCliente,
      IdTipoCredito: this.configService.etiquetas.Cuentas.IdTipoCredito,
      IdZonaVendedor: this.configService.etiquetas.Cuentas.IdZonaVendedor,
      LimiteCredito: this.configService.etiquetas.Cuentas.LimiteCredito,
      Nombre: this.configService.etiquetas.Cuentas.Nombre,
      NroCliente: this.configService.etiquetas.Cuentas.NroCliente,
      NroClientePartner: this.configService.etiquetas.Cuentas.NroClientePartner,
      Pais: this.configService.etiquetas.IdPais,
      Provincia: this.configService.etiquetas.Cuentas.Provincia,
      Region: this.configService.etiquetas.Cuentas.Region,
      SinRegistros: this.configService.etiquetas.SinRegistros,
      SitioInternet: this.configService.etiquetas.Cuentas.SitioInternet,
      Status: this.configService.etiquetas.Cuentas.Status,
      Telefono: this.configService.etiquetas.Cuentas.Telefono,
      Email: this.configService.etiquetas.Cuentas.Email,
      EmailOpcional: this.configService.etiquetas.EmailOpcional,
      SalesOffice: this.configService.etiquetas.SalesOffice,
      CodigoBodegaMyV: this.configService.etiquetas.CodigoBodegaMyV,
      CodigoBodegaCoagra: this.configService.etiquetas.CodigoBodegaCoagra
    }

    if (this.codigoEdit != -1) {

      loadData(this.form, this.direccion)

    }


  }

  guardar() {

    switch (this.idTipo) {

      case 2:

        this.cuentasService.mDireccion(this.form.value).subscribe((data: boolean) => {
          this.mensaje = this.idTipo;
          this.dialogRef.close();
        });
        break;
    }

  }





  isMobileXL() {
    return isMobileXL();
  }

  isMobile() {
    return isMobile();
  }

  clearInput(formControlName: string) {
    this.form.controls[formControlName].reset();
  }

  isInRole(rol: string): boolean {
    return this.loggedService.isInRole(rol);
  }


}
